import { createStyles, makeStyles } from '@material-ui/core';
import { Colors } from '../../../../layout/theme-next';

export default makeStyles((theme) =>
  createStyles({
    root: {
      pointerEvents: 'none',
    },
    paper: {
      pointerEvents: 'auto',
      width: '80vw',
      padding: theme.spacing(3),
    },
    usagePaper: {
      padding: theme.spacing(3),
    },
    columnNameInput: {
      fontSize: '16px',
    },
    content: {
      padding: theme.spacing(0, 1),
    },
    fullWidth: {
      width: '100%',
    },
    genericFlex: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
    },
    stagesContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: `${theme.spacing(3)}px`,
      overflowX: 'auto',
      overflowY: 'hidden',
      alignItems: 'stretch',
      padding: theme.spacing(4, 2, 0, 2),
      marginTop: theme.spacing(2.5),
      height: '54vh',
    },
    loadingContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
    stageWrapper: {
      flexShrink: 0,
      width: theme.spacing(54),
      position: 'relative',
    },
    stageBox: {
      height: '50vh',
      display: 'flex',
      flexDirection: 'column',

      position: 'relative',

      backgroundColor: '#fff',
      borderRadius: 8,

      boxShadow: `0 4px 12px ${Colors.lightGray}`,
    },
    stageTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(0, 2),
      position: 'absolute',
      width: '100%',
      top: theme.spacing(-3),
    },
    stageHeader: {
      alignItems: 'center',
      padding: theme.spacing(2),
      borderBottom: `1px solid ${Colors.lightGray}`,
    },
    stageHeaderRight: {
      padding: theme.spacing(2, 0, 0, 0),
    },
    customTooltip: {
      backgroundColor: Colors.black,
      whiteSpace: 'pre-wrap',
    },
    customArrow: {
      color: Colors.black,
    },
    optionalApproverSelect: {
      marginLeft: 0,
      gap: `${theme.spacing(1)}px`,
    },
    approverList: {
      flex: 1,
      overflowY: 'auto',
      minHeight: 0,
    },
    stageFooter: {
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    addApproverContainer: {
      margin: theme.spacing(1.5, 0, 0, 0),
      padding: theme.spacing(1),
    },
    toggleButtonGroups: {
      width: '100%',
    },
    toggleButton: {
      flex: 1,
    },
    editableStageName: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
      cursor: 'pointer',
      fontSize: '14px',
      '&:hover': {
        opacity: 0.75,
      },
    },
    editNameIcon: {
      color: Colors.textGray,
      fontSize: 14,
      marginLeft: theme.spacing(1),
    },
    stageNameField: {
      '& >div': {
        position: 'relative',
        top: theme.spacing(-0.5),
        border: 0,
        '& input': {
          padding: 0,
          border: 0,
        },
        '& fieldset': {
          border: 0,
        },
      },
    },
    deleteIcon: {
      cursor: 'pointer',
      color: Colors.error,
      fontSize: 16,
      marginLeft: theme.spacing(1),
    },
    deleteIconBox: {
      cursor: 'pointer',
      color: Colors.error,
      fontSize: theme.spacing(1.5),
    },
    addApproverBtn: {
      margin: 0,
      padding: theme.spacing(1.5),
      width: '100%',
      border: 0,
    },
    actionBtns: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing(2),
      borderTop: `1px solid ${Colors.lightGray}`,
    },
    addStage: {
      backgroundColor: 'transparent',
    },
    btnGroup: {
      display: 'flex',
      gap: `${theme.spacing(1)}px`,
      alignItems: 'center',
    },
    switchControlEnabledAr: {
      position: 'absolute',
      top: theme.spacing(-6.5),
      right: 0,
      display: 'flex',
      alignItems: 'center',
    },
    switchControlEnabled: {
      position: 'absolute',
      top: theme.spacing(-2),
      right: 0,
      display: 'flex',
      alignItems: 'center',
    },
    switchControlDisabledAr: {
      position: 'absolute',
      top: theme.spacing(-6.5),
      right: 0,
      display: 'flex',
      alignItems: 'center',
    },
    switchControlDisabled: {
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'flex',
      alignItems: 'center',
    },
    mappingSwitcher: {
      display: 'flex',
      flexDirection: 'row',
      marginRight: theme.spacing(0),
      '& span': {
        fontSize: 12,
        fontWeight: 600,
      },
    },
    switchBase: {
      color: Colors.statusDraftBorder,
      '&$checked': {
        color: Colors.statusDraftBorder,
      },
    },
    approverRow: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1),
    },
    approverContent: {
      flex: 1,
      minWidth: 0,
    },
    approverName: {
      fontSize: '14px',
      fontWeight: 500,
    },
    groupHeader: {
      display: 'flex',
      alignItems: 'baseline',
      cursor: 'pointer',
    },
    groupExpandIcon: {
      position: 'relative',
      top: theme.spacing(0.5),
      marginRight: theme.spacing(1),
    },
    groupName: {
      display: 'inline-block',
      marginTop: theme.spacing(0.5),

      padding: theme.spacing(0.25, 1),

      borderRadius: `${theme.spacing(5)}px`,

      fontSize: theme.spacing(1.6),
      fontWeight: 400,

      backgroundColor: Colors.lightGray,
    },
    groupDetails: {
      fontSize: '12px',
      marginTop: theme.spacing(0.5),
    },
    employeeList: {
      marginLeft: theme.spacing(4),
    },
    employeeName: {
      display: 'list-item',
      listStyle: 'decimal-leading-zero',
    },
    tableHead: {
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: Colors.gray,
      color: Colors.textBlack,
      fontSize: '12px',
      fontWeight: 'bold',
      padding: theme.spacing(1),
    },
    tableRow: {
      display: 'flex',
      gap: `${theme.spacing(1)}px`,
      marginTop: theme.spacing(2),
      alignItems: 'baseline',
      padding: theme.spacing(0.5, 1),
    },
    tableCellSerialNum: {
      width: '5%',
    },
    tableCellOne: {
      width: '75%',
      borderRadius: theme.spacing(0.5, 0, 0, 0),
    },
    tableCellOnePadding: {
      paddingLeft: theme.spacing(2),
    },
    tableCellTwo: {
      width: '15%',
    },
    userHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
    },
    configurationOption: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: `${theme.spacing(1)}px`,
    },
    optionName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: Colors.textBlack,
    },
    chipOptions: {
      display: 'flex',
      gap: `${theme.spacing(1)}px`,
      flexShrink: 0,
    },
    chip: {
      fontSize: theme.spacing(1.3),
      height: '20px',
    },
    configurationDetails: {
      position: 'relative',
      color: Colors.textGray,
      top: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.75),
    },
    optionDetails: {
      position: 'relative',
      top: '-2px',
      color: Colors.textGray,
    },
    validationPanel: {
      margin: theme.spacing(0, 0, 2),
      padding: theme.spacing(2),

      borderRadius: theme.spacing(1),

      backgroundColor: Colors.errorHighlight,
      border: `1px solid ${Colors.errorLight}`,

      boxShadow: `0 1px 3px ${Colors.errorLightShadow}`,

      position: 'absolute',
      width: '100%',
      zIndex: 10,
    },
    validationError: {
      color: Colors.error,
      fontSize: theme.spacing(1.75),
      lineHeight: 1.7,
    },
    check: {
      fontSize: 18,
      color: Colors.success,
      fontWeight: 600,
      marginRight: theme.spacing(0.5),
    },
    notFulfilled: {
      fontSize: 18,
      color: Colors.remove,
      fontWeight: 600,
      marginRight: theme.spacing(0.5),
    },
    partiallyFulfilled: {
      fontSize: 18,
      color: Colors.warning,
      fontWeight: 600,
      marginRight: theme.spacing(0.5),
    },
    dialogHeader: {
      fontSize: 20,
      fontWeight: 600,
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      // borderBottom: `1px solid ${theme.palette.divider}`,
    },
    requiredGroupsContainer: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      padding: theme.spacing(1, 2, 2),
      margin: 0,
    },
    requiredGroupsLegend: {
      padding: theme.spacing(0, 1),
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    approverGroup: {
      marginRight: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
    },
    usageDialogContent: {
      padding: theme.spacing(0, 2.5),
    },
    usageSubtitle: {
      fontSize: 14,
      marginBottom: theme.spacing(2),
    },
    usageSection: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      padding: theme.spacing(1, 2, 2),
      margin: theme.spacing(2, 0),
    },
    usageLegend: {
      padding: theme.spacing(0, 1),
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    selectControl: {
      marginLeft: 0,
    },
    usageEntry: {
      display: 'flex',
      alignItems: 'flex-start',
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1, 0),
      gap: `${theme.spacing(0.75)}px`,

      '&:last-child': {
        borderBottom: 'none',
      },

      '& p': {
        lineHeight: 0.5,
      },
    },
    noConfigurationMsg: {
      padding: theme.spacing(2),
      fontSize: 14,
      color: theme.palette.text.secondary,
      lineHeight: 1.75,
    },
  }),
);
